<div class="chat-it-tab-content">
  <div class="tab-header">
    <h4>Chat IT</h4>
    <p>AI-powered data assistance and chat interface</p>
  </div>
  
  <div class="tab-body">
    <div class="placeholder-content">
      <i class="material-icons">chat</i>
      <h5>Chat IT Functionality</h5>
      <p>This section will contain AI-powered data assistance tools.</p>
     
    </div>
  </div>
</div>
